<eif-invitation-screen
	[invitationScreenType]="'supplierConfirming'"
	[token]="token"
	[invitingCompany]="invitingCompany"
	[invitedCompany]="invitedCompany"
	[invitedUser]="invitedUser"
	[invitedUserEmail]="invitedUserEmail"
	[registerUserInput]="registerUserInput"
	[newUser]="newUser"
	[languageCodes]="languageCodes"
	[timeZones]="timeZones"
	[pageDisplayLanguageCode]="pageDisplayLanguageCode"
	[contractData]="fundingRequestConfirmingContract"
	[bankAccountData]="bankAccountData"
	(acceptInvitation)="onAcceptInvitation($event)"
	(refuseInvitation)="onRefuseInvitation($event)"
	(documentsUpdated)="onDocumentsUpdated($event)"
	(pageDisplayLanguageCodeChange)="onPageDisplayLanguageCodeChange($event)"
	[showSucessSubmission]="showSucessSubmission"
	[sucessSubmissionContent]="sucessSubmissionContent"
	[requestErrors]="requestErrors"
	[isSubmittingAccept]="isSubmittingAccept"
	[isSubmittingRefuse]="isSubmittingRefuse">
</eif-invitation-screen>
